import { info } from './getPublisher'
import { list } from './list'

export default {
  ...list,
  ...info
}
